/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import EditableText from 'material/embeds/editabletext/editabletext_container';
import Delete from 'material/embeds/content/edit/delete/delete_container';
import Correct from 'material/embeds/content/edit/correct/correct_container';
import ImageIndicator from 'material/embeds/imageindicator/imageindicator';
// utils
import { url } from 'utils/urls';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/content/shared/answer/image1/image1_styles';



/* ========== ~~~~~~~~~~ EMBED : ANSWER : IMAGE 1 ~~~~~~~~~~ ========== */
class AnswerImage1 extends Component {
    constructor(props) {
        super(props);
        this.state = { selected: false, isImageValid: null, isTextValid: null };
        this.characterLimit = 15;
        this.handleImageSelect = this.handleImageSelect.bind(this);
        this.handleTextSelect = this.handleTextSelect.bind(this);
        this.getInlineStyles = this.getInlineStyles.bind(this);
        this.validateOption = this.validateOption.bind(this);
    }
    componentWillMount() {
        if (this.props.isEditable) {
            this.validateOption(this.props.text, this.props.imageURL, true);
        }
    }
    componentDidUpdate(prevProps) {
        if (this.props.isEditable && (this.props.text !== prevProps.text || this.props.imageURL !== prevProps.imageURL)) {
            this.validateOption(this.props.text, this.props.imageURL, false);
        } else if (this.props.isValid === false && (this.props.isValid !== prevProps.isValid)) {
            this.validateOption(this.props.text, this.props.imageURL, false);
        }
    }
    validateOption(text = this.props.text, image = this.props.imageURL, isInitialValidation = false) {
        const isTextValid = this.validateText(text, isInitialValidation);
        const isImageValid = this.validateImage(image, isInitialValidation);
        const isValid = (isTextValid === null && isImageValid === null) ? null : isTextValid && isImageValid ? true : { isImageValid, isTextValid };
        if(isValid !== this.props.isValid) this.props.updateOptionProperty(this.props.contentId, this.props.optionId, 'isValid', isValid);
    }
    validateImage = (imageURL, isInitialValidation) => (
        isInitialValidation ? imageURL === null ? imageURL : true : imageURL !== null
    );
    handleKeyUp = text => this.validateOption(text);
    validateText(text, isInitialValidation) {
        const trimmedText = text !== null ? text.trim() : '';
        if(trimmedText.length > this.characterLimit) { return null; }
        if (trimmedText.length === 0) {
            return isInitialValidation ? this.props.text === null ? this.props.text : true : false;
        } else if (trimmedText.length > 0) {
            return true;
        }
    }
    handleImageSelect() {
        this.props.setActiveSelection(this.props.isSelected ? 'none' : `option_${this.props.optionId}`);
    }
    handleTextSelect(text) {
        this.setState({ selected: !this.state.selected });
    }
    getInlineStyles() {
        const imgURL = this.props.imageURL === null ? `url(${url.image}/embed-default-image-${this.props.optionId}.jpg` : `url(${this.props.imageURL})`;
        const imgSrc = this.props.previewImageURL === null ? imgURL : `url(${this.props.previewImageURL})`;
        return { backgroundImage: imgSrc };
    }
    render() {
        const isImageValid = this.props.isValid instanceof Object ? this.props.isValid.isImageValid : this.props.isValid;
        const isTextValid = this.props.isValid instanceof Object ? this.props.isValid.isTextValid : this.props.isValid;
        const placeholderText = `Answer here`;
        return (
            <div className={`image1 ${this.props.classes.image1}`}>
                <span className={`photo`}>
                    <span className={`graphic selected-${this.props.isEditable && this.props.isSelected} valid-${!this.props.isEditable || isImageValid} editable-${this.props.isEditable}`} style={this.getInlineStyles()} onClick={this.handleImageSelect}>
                        <span className={`overlay`} />
                        <ImageIndicator color={`white`} />
                    </span>
                    <span className={`background selected-${this.state.selected} valid-${!this.props.isEditable || isTextValid} duplicate-${this.props.isDuplicate}`}><span className={`overlay`} /></span>
                    <span className={`desc`}>
                        <span className={`text`}>
                            <EditableText
                                key={`${this.props.isEditable ? `editor` : `card`}-option-${this.props.contentId}${this.props.optionId}`}
                                contentId={this.props.contentId}
                                isOption={true}
                                textType={'image1'}
                                optionId={this.props.optionId}
                                placeholderText={placeholderText}
                                isEditable={this.props.isEditable}
                                onFocus={this.handleTextSelect}
                                onBlur={this.handleTextSelect}
                                onKeyUp={this.handleKeyUp}
                                characterLimit={this.characterLimit}
                                preventEnter={true}
                            />
                        </span>
                    </span>
                    <Delete contentId={this.props.contentId} optionId={this.props.optionId} position={`top right`} />
                    <Correct contentId={this.props.contentId} optionId={this.props.optionId} type={`image1`} />
                </span>
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(AnswerImage1);
